/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {getEmailTemplate} from '../../../../services/emailtemplate.service'
import {EmailTemplateModel} from '../../../../model/emailtemplate.model'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {getMasterService, getModule} from '../../../../services'
import {ModuleModel} from '../../../../model'

const TableModules: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const [module, setModule] = useState<ModuleModel[]>([])
  const [statusEmail, setStatusEmail] = useState<ModuleModel[]>([])

  useEffect(() => {
    getApplicationList()
    getStatusEmail()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getStatusEmail = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoEmail',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatusEmail(mappedMaster)
    } catch (error) {
      setStatusEmail([])
    }
  }
  const getApplicationList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getModule({}, 1)
      const data = response.data.data
      const mappedSites: ModuleModel[] = data.map((item) => ({
        value: item.id || '',
        label: item.nombre || '',
      }))

      setModule(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  useEffect(() => {
    getEmailTemplateList()
  }, [pagination.currentPage])

  useEffect(() => {
    setLoading(loading)
  }, [loading])

  useEffect(() => {
    setInitialPagination()
  }, [currentTabItem.loadingTable])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getEmailTemplateList()
    }
  }, [currentTabItem.loadingTable])

  const getEmailTemplateList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getEmailTemplate(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-emailtemplate',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id

    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const setInitialPagination = async () => {
    const {data: response} = await getEmailTemplate(searchValues, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getEmailTemplateList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  const columns: Column<EmailTemplateModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo'
            name='aplicacionId'
            data={module}
            selecteable
          />
        ),
        accessor: 'aplicacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Código Plantilla' name='id' searcheable />
        ),
        accessor: 'codigo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombre Email' name='nombre' searcheable />
        ),
        accessor: 'nombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='De' name='de' searcheable />,
        accessor: 'de',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Para' name='para' searcheable />,
        accessor: 'para',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Asunto' name='asunto' searcheable />
        ),
        accessor: 'asunto',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Tabla' name='tabla' searcheable />
        ),
        accessor: 'tabla',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Columna' name='idColumna' searcheable />
        ),
        accessor: 'idColumna',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='estado'
            data={statusEmail}
            selecteable
          />
        ),
        accessor: 'nombreEstado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}{' '}
          </>
        ),
      },
    ],
    [module, statusEmail, selectedOn],
  )

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getEmailTemplateList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2 w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableEmailTemplateWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Plantillas email</Tab>
          </TabList>
          <TabPanel>
            <TableModules />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableEmailTemplateWrapper}
